import { render, staticRenderFns } from "./SearchVehicleResults.vue?vue&type=template&id=5add4a37&scoped=true"
import script from "./SearchVehicleResults.vue?vue&type=script&lang=js"
export * from "./SearchVehicleResults.vue?vue&type=script&lang=js"
import style0 from "./SearchVehicleResults.vue?vue&type=style&index=0&id=5add4a37&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5add4a37",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SsrCarousel: require('/app/node_modules/vue-ssr-carousel/index.js').default})
